import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { FAQS, COMPANY } from "../lib/constants";

const FAQ = () => {
  return (
    <div data-testid="faq-page" className="bg-[#050914] text-white">
      <section className="pt-40 pb-16 md:pt-48 md:pb-20 border-b border-white/10">
        <div className="max-w-[1100px] mx-auto px-6 md:px-12">
          <div className="text-[11px] uppercase tracking-[0.3em] text-slate-400 mb-6">FAQ</div>
          <h1 className="font-display font-bold text-5xl md:text-6xl lg:text-7xl leading-[0.95]">
            Answers to the questions
            <br />
            <span className="text-silver">people actually ask.</span>
          </h1>
        </div>
      </section>

      <section className="py-20 md:py-28">
        <div className="max-w-[900px] mx-auto px-6 md:px-12">
          <Accordion type="single" collapsible className="space-y-4" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border border-white/10 bg-[#0B132B]/40 px-6"
              >
                <AccordionTrigger className="text-left text-base md:text-lg font-display font-semibold text-white hover:no-underline py-6">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-300 leading-relaxed pb-6 text-base">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          <div className="mt-16 border border-white/10 bg-[#0B132B]/40 p-8 md:p-12 text-center">
            <h3 className="font-display font-semibold text-2xl md:text-3xl mb-4">
              Still have questions?
            </h3>
            <p className="text-slate-400 mb-8 max-w-md mx-auto">
              Talk to a real Ferrer coordinator — same person who handles your transport, start to finish.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href={`tel:${COMPANY.phoneRaw}`}
                data-testid="faq-call-cta"
                className="inline-flex items-center justify-center gap-3 bg-white text-[#050914] px-7 py-4 text-[12px] uppercase tracking-[0.25em] font-semibold hover:bg-slate-200"
              >
                <Phone className="w-4 h-4" />
                {COMPANY.phone}
              </a>
              <Link
                to="/#quote"
                data-testid="faq-quote-cta"
                className="inline-flex items-center justify-center gap-3 border border-white/30 text-white px-7 py-4 text-[12px] uppercase tracking-[0.25em] font-semibold hover:bg-white hover:text-[#050914]"
              >
                Free Quote <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;
